// extracted by mini-css-extract-plugin
export default {"label":"Label_label__sYrL4","container":"Label_container__c5NMT","text":"Label_text__UG-4D","valueText":"Label_valueText__W+yWi"};